const constants = {
  roles: {
    admin: "Administrator",
    dataEntry: "Data Entry",
    contentEdit: "Content Editor",
  },
};

export default constants;
